import { compose, lensPath, set, view } from 'ramda'
import { isTrue } from 'ramda-adjunct'
import pipe from 'ramda/src/pipe'
import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import UserContext from '../../../context/UserContext'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import HubAboutNhsTherapyPage from './HubAboutNhsTherapyPage'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub-about-nhs-therapy`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const canAccessProgrammeLens = lensPath([`canAccessProgramme`])
const getCanAccessProgrammeLens = view(canAccessProgrammeLens)

const getEnrolmentCanAccessProgramme = pipe(getCanAccessProgrammeLens, isTrue)

const getCurrentEnrolmentHasOpenReferralRequest = (currentEnrolment) => {
  const { nodes } = currentEnrolment.referralRequests
  return nodes.some((node) => node.status === `open`)
}

const setPagesHubSleepImprovementPlanCardLinkUrl = set(
  compose(lensPath([`page`, `content`, `ctaButton`, `url`]))
)
const setPagesHubSleepImprovementPlanCardSecondaryLinkUrl = set(
  compose(lensPath([`page`, `content`, `ctaButtonSecondary`, `url`]))
)

const injectRouting = (routing, content) =>
  pipe(
    setPagesHubSleepImprovementPlanCardLinkUrl(routing.preAssessmentPath),
    setPagesHubSleepImprovementPlanCardSecondaryLinkUrl(
      routing.preAssessmentPath
    )
  )(content)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubAboutNhsTherapyModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { currentEnrolment } = useContext(UserContext)
  const canEnrolmentAccessProgramme =
    getEnrolmentCanAccessProgramme(currentEnrolment)
  const enrolmentHasOpenReferralRequest =
    getCurrentEnrolmentHasOpenReferralRequest(currentEnrolment)
  const { appRouting } = useContext(RoutingContext)
  const loaderDataWithRouting = injectRouting(appRouting, loaderData)

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return (
    <HubAboutNhsTherapyPage
      content={loaderDataWithRouting.page.content}
      canEnrolmentAccessProgramme={canEnrolmentAccessProgramme}
      enrolmentHasOpenReferralRequest={enrolmentHasOpenReferralRequest}
    />
  )
}

export default HubAboutNhsTherapyModule
